// extracted by mini-css-extract-plugin
module.exports = {"content":"ea","container":"eb","title":"ec","text":"ed","textForm":"ee","submitButton":"ef"};